import {formatCustomDate} from "../../utility/Utils";
import {format} from "date-fns";

/**
 * mapped Transactions
 * @param values
 * @param startDate
 * @param years - array of years from API (e.g. [2025] or [2025, 2026] for cross-year periods)
 * @returns {{unit: string, datasets: [{data: unknown[], label: string}], labels: (*|Date)[]}}
 */
export const mappedTransactions = (values, startDate, years = null) => {
    const keys = values ? Object.keys(values) : [];

    const labels = keys.map((key, index) => {
        let year = null;
        if (years?.length > 0) {
            // Track year rollovers: when month number decreases, move to next year in array
            let yearIndex = 0;
            for (let i = 1; i <= index; i++) {
                if (parseInt(keys[i]) < parseInt(keys[i - 1])) yearIndex++;
            }
            year = years[Math.min(yearIndex, years.length - 1)];
        }
        return formatCustomDate(startDate, key, 'month', year);
    });

    return {
        unit: 'month',
        labels,
        datasets: [
            {
                label: 'Transactions',
                data: values ? Object.values(values) : [],
            },
        ],
    };
};

/**
 * mapped Sales By Date
 * @param values
 * @param startDate
 * @returns {{unit: string, datasets: {data: unknown[], label: string}, labels: (*|Date)[]}}
 */
export const mappedSalesByDate = (values, startDate) => ({
    unit: 'day',
    labels: values && Object.keys(values).map((key) => formatCustomDate(startDate, key, 'day')),
    datasets: {
        data: values && Object.values(values).map((value) => value),
        label: '',
    },
});

/**
 * mapped Sales By Part of Day
 * @param values
 * @returns {{datasets: {data: unknown[]}, labels: string[]}}
 */
export const mappedSalesByPartDay = (values) => ({
    labels: values && Object.keys(values).map((key) => key),
    datasets: {
        data: Object.values(values).map((value) => value),
    },
});

/**
 * mapped Sales By Week Day
 * @param values
 * @returns {{datasets: {data: unknown[], label: string}, labels: string[]}}
 */
export const mappedSalesByWeekDay = (values) => ({
    labels: values && Object.keys(values).map((key) => key),
    datasets: {
        label: 'Turnover',
        data: values && Object.values(values).map((value) => value),
    },
});

/**
 * mapped Sales By Hours of Day
 * @param values
 * @param startDate
 * @returns {{unit: string, datasets: {data: unknown[]}, labels: string[]}}
 */
export const mappedSalesByHoursDay = (values, startDate) => ({
    unit: 'hour',
    labels: values && Object.keys(values).map((key) =>
        format(formatCustomDate(startDate, key, 'hour'), 'yyyy-MM HH:mm'),
    ),
    datasets: {data: values && Object.values(values).map((value) => value)},
});
